export default __webpack_public_path__ + "static/media/imagePickAndPackContentSix.f5e419b8.png";